export const FIELDS = {
  ID: 'id',
  ACCOUNT_ID: 'accountId',
  COMPANY_NAME: 'companyName',
  ADDRESS_TYPE_ID: 'addressTypeId',
  NAME: 'name',
  ADDRESS_TYPE_NAME: 'addressTypeName',
  FULL_ADDRESS: 'fullAddress',
  ADDRESS1: 'address1',
  ADDRESS2: 'address2',
  ADDRESS3: 'address3',
  CITY: 'city',
  STATE: 'state',
  ZIP_CODE: 'zipCode',
  COUNTRY_CODE: 'countryCode',
  COUNTRY: 'country',
  ADDRESS_VAT: 'addressVat',
  CONTACT_NAME: 'contactName',
  PHONE: 'phone',
  FAX: 'fax',
  CONTACT_ID: 'contactId',
  TAX_ID: 'taxId',
  VATNUMBER: 'vatNumber',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  IS_DEFAULT: 'isDefault',
  ACTIVE: 'active',};